import { Heading } from '../../typography/heading/Heading';
import { Text } from '../../typography/text/Text';
import Title from '../../typography/title/Title';
import { StylesCustomizer } from '../../molecules/stylesCustomizer';
import styles from './ContentTitle.module.scss';
import PropTypes from 'prop-types';
import React from 'react';

const ContentTitle = ({
  titleMaxWidth,
  titleTag,
  titleItems,
  verticalPaddingDesktop,
  verticalPaddingMobile,
  textStyles,
}) => {

  const TitleItem = ({ variables }) => {
    return (
      titleItems &&
      titleItems.map((item, index) => {
        const { type, titleItemText = '' } = item;
        switch (type) {
          case 'label':
            return (
              <Text
                key={`label_${index}`}
                as="span"
                variables={variables}
                inlineStyles={variables}
              >
                {titleItemText}
              </Text>
            );
          case 'text':
            return (
              <Text
                as="p"
                key={`text_${index}`}
                className={styles.text}
                variables={variables}
                inlineStyles={variables}
              >
                {titleItemText}
              </Text>
            );
          case 'title':
            return (
              <Heading
                key={`heading_${index}`}
                placement="common"
                as={titleTag}
                className={styles.title}
                variables={variables}
                inlineStyles={variables}
              >
                {titleItemText}
              </Heading>
            );
          default:
            return null;
        }
      })
    );
  }


  const TitleWrapper = (variables) => {
    return (
      <Title
        className={styles.root}
        variables={variables}
      >
        <TitleItem variables={variables} />
      </Title>
    );
  };

  const StyledText = StylesCustomizer(TitleWrapper);

  return (
    <div
      style={{
        '--vertical-padding-desktop': verticalPaddingDesktop
          ? verticalPaddingDesktop + 'px'
          : '0',
        '--vertical-padding-mobile': verticalPaddingMobile
          ? verticalPaddingMobile + 'px'
          : '0',
        '--title-max-width': titleMaxWidth ? `${titleMaxWidth}px` : '100%',
      }}
    >
      <StyledText styles={textStyles} />
    </div>
  );
};

ContentTitle.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ContentTitle.defaultProps = {
  label: '',
  title: '',
  subtitle: '',
};

export default ContentTitle;
